import React, {useEffect, useState} from "react";
import axios from "axios";
import {useParams} from "react-router-dom";
import {baseUrl} from "../Univ";
function PurchaseRequestPrint() {
    const {id} = useParams();
    const [request, setRequest] = useState(null);
    const [items, setItems] = useState([]);
    useEffect(() => {
        loadPurchaseRequest();
    }, []);
    const loadPurchaseRequest = async () => {
        try {
            // Header
            const res = await axios.get(baseUrl + "update-purchase-request/" + id + "/");
            setRequest(res.data);
            // Detail Items
            const itemRes = await axios.get(baseUrl + "purchase-request-item/" + id + "/");
            setItems(itemRes.data);
        } catch (err) {
            console.log(err);
        }
    };
    const handlePrint = () => {
        const printContents = document.getElementById("print-area").innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 500);
        document.body.innerHTML = originalContents;
    };
    if (!request) {
        return (<div className="container mt-5 text-center">

                <h4>Loading Purchase Request...</h4>

            </div>);
    }
    return (<section className="container-fluid">

            <div id="print-area">

                {/* ===========================
                    COMPANY HEADER
                ============================ */}

                <table
                    width="100%"
                    cellPadding="4"
                >

                    <tbody>

                    <tr>

                        <td width="70%">

                            <h2
                                style={{
                                    marginBottom: 0, color: "#198754"
                                }}
                            >
                                EAgri ERP
                            </h2>

                            <h5
                                style={{
                                    marginTop: 5
                                }}
                            >
                                MGM EBuild Private Limited
                            </h5>

                            <div>

                                Chennai, Tamil Nadu

                            </div>

                            <div>

                                support@mgmebuild.com

                            </div>

                            <div>

                                +91 XXXXX XXXXX

                            </div>

                        </td>

                        <td
                            width="30%"
                            align="right"
                        >

                            <h2
                                style={{
                                    border: "2px solid #198754", padding: "10px", color: "#198754"
                                }}
                            >
                                PURCHASE REQUEST
                            </h2>

                        </td>

                    </tr>

                    </tbody>

                </table>

                <hr/>
                {/* ==========================================
                    PURCHASE REQUEST DETAILS
                =========================================== */}

                <table
                    width="100%"
                    cellPadding="6"
                    style={{
                        marginTop: "20px", borderCollapse: "collapse"
                    }}
                    border="1"
                >

                    <tbody>

                    <tr>

                        <td width="25%">
                            <b>Request No</b>
                        </td>

                        <td width="25%">
                            {request.request_no}
                        </td>

                        <td width="25%">
                            <b>Request Date</b>
                        </td>

                        <td width="25%">
                            {request.request_date}
                        </td>

                    </tr>

                    <tr>

                        <td>
                            <b>Requested By</b>
                        </td>

                        <td>
                            {request.requested_by?.name}
                        </td>

                        <td>
                            <b>Status</b>
                        </td>

                        <td>

                            <span
                                style={{
                                    fontWeight: "bold",
                                    color: request.status === "APPROVED" ? "green" : request.status === "REJECTED" ? "red" : "#d97706"
                                }}
                            >
                                {request.status}
                            </span>

                        </td>

                    </tr>

                    <tr>

                        <td>

                            <b>Purpose</b>

                        </td>

                        <td colSpan="3">

                            {request.purpose}

                        </td>

                    </tr>

                    </tbody>

                </table>

                {/* ==========================================
                    ITEM DETAILS
                =========================================== */}

                <h4
                    style={{
                        marginTop: "30px", color: "#198754"
                    }}
                >
                    Requested Items
                </h4>

                <table
                    width="100%"
                    border="1"
                    cellPadding="7"
                    style={{
                        borderCollapse: "collapse"
                    }}
                >

                    <thead>

                    <tr
                        style={{
                            background: "#198754", color: "#fff"
                        }}
                    >

                        <th width="8%">
                            S.No
                        </th>

                        <th width="35%">
                            Item Name
                        </th>

                        <th width="20%">
                            Category
                        </th>

                        <th width="15%">
                            Unit
                        </th>

                        <th width="12%">
                            Qty
                        </th>

                        <th width="10%">
                            Stock
                        </th>

                    </tr>

                    </thead>

                    <tbody>

                    {items.map((item, index) => (<tr key={item.id}>

                            <td align="center">

                                {index + 1}

                            </td>

                            <td>

                                {item.item?.item_name}

                            </td>

                            <td>

                                {item.item?.category?.name}

                            </td>

                            <td align="center">

                                {item.item?.unit}

                            </td>

                            <td align="right">

                                {item.quantity}

                            </td>

                            <td align="right">

                                {item.item?.current_stock}

                            </td>

                        </tr>))}

                    </tbody>

                </table>
                {/* ==========================================
                    APPROVAL / REMARKS
                =========================================== */}

                <table
                    width="100%"
                    border="1"
                    cellPadding="8"
                    style={{
                        marginTop: "30px", borderCollapse: "collapse"
                    }}
                >

                    <tbody>

                    <tr>

                        <td width="20%">
                            <b>Remarks</b>
                        </td>

                        <td>

                            {request.remarks || "-"}

                        </td>

                    </tr>

                    </tbody>

                </table>

                {/* ==========================================
                    SIGNATURES
                =========================================== */}

                <table
                    width="100%"
                    style={{
                        marginTop: "70px"
                    }}
                >

                    <tbody>

                    <tr>

                        <td align="center">

                            ______________________

                            <br/>

                            Requested By

                            <br/>

                            {request.requested_by?.name}

                        </td>

                        <td align="center">

                            ______________________

                            <br/>

                            Department Head

                        </td>

                        <td align="center">

                            ______________________

                            <br/>

                            Purchase Manager

                        </td>

                        <td align="center">

                            ______________________

                            <br/>

                            Authorized Signatory

                        </td>

                    </tr>

                    </tbody>

                </table>

            </div>

            <div
                className="text-center mt-4 mb-5"
            >

                <button
                    className="btn btn-success"
                    onClick={handlePrint}
                >

                    Print Purchase Request

                </button>

            </div>

        </section>);
}
export default PurchaseRequestPrint;